import { useCustom } from "@pankod/refine-core";
import { IRole } from "interfaces";
import { API_URL } from "../../constants";

const roleLabels: Record<string, string> = {
  Administrator: "Administrador",
  administrator: "Administrador",
  Moderator: "Moderador",
  moderator: "Moderador",
  Reader: "Lector",
  reader: "Lector",
  Consulta: "Lector",
};

const allowedRoles = new Set(Object.keys(roleLabels));

export const getRoleLabel = (role?: { name?: string; type?: string }) => {
  if (!role) return "";
  return (
    roleLabels[role.name || ""] ||
    roleLabels[role.type || ""] ||
    role.name ||
    ""
  );
};

export const useRoles = () => {
  const { data, isLoading } = useCustom({
    url: `${API_URL}/api/users-permissions/roles`,
    method: "get",
  });

  const rawRoles = data?.data?.roles || [];
  const roles: IRole[] = rawRoles
    .filter(
      (role: IRole) =>
        allowedRoles.has(role.type || "") || allowedRoles.has(role.name || "")
    )
    .map((role: IRole) => ({
      ...role,
      name: getRoleLabel(role) || role.name,
    }));

  return { roles, isLoading };
};
